export const SkeletonLoadingConfig = {
  width: 120,
  height: 100,
  amount: 9,
};

// Web app's Firebase configuration
// This values are extracted from:  Project settings -> Your apps -> select the WebApp =-> SDK setup and configuration
export const messagingConfig = {
  firebase: {
    apiKey: 'AIzaSyCP4BKbKchj7aM2_IqvmIJBKC6dnkMamwU',
    authDomain: 'teak-proton-332617.firebaseapp.com',
    projectId: 'teak-proton-332617',
    storageBucket: 'teak-proton-332617.appspot.com',
    messagingSenderId: '878955735510',
    appId: '1:878955735510:web:62951d729c3af6fd225c77',
    measurementId: 'G-Q41LTZ17W2',
  },
  webPushCertificates: {
    vapidKey:
      'BOsVFE53flywbE2-UmGYlj93my-y5TTGOu2_-po-bUQ0ucaqSL18oG2o_tIlK811AHxmiNNsKZyi3WecRXr-j-w',
  },
};
